if (!customElements.get("td-modal")) {
  class tdModal extends HTMLElement {
    constructor() {
      super();
      this.modalTrigger = this.querySelector('[data-icon-modal-trigger]');
      this.modalContent = this.querySelector('.td-ugc__modal');
      this.modalOverlayContent = this.querySelector('.td-ugc__overlay');
      this.closeButton = this.querySelector('.td-ugc__modal .icon-close');
      this.mainContainer = document.querySelector('#main');
      this.body = document.querySelector('body');
      this.dragThreshold = 10;
    }

    connectedCallback() {
      this.modalTrigger.addEventListener('mousedown', this.handleMouseDown.bind(this));
      this.modalTrigger.addEventListener('mouseup', this.handleMouseUp.bind(this));
      this.modalTrigger.addEventListener('click', this.handleClick.bind(this));
      this.modalOverlayContent.addEventListener('click', this.closeModal.bind(this));
      this.closeButton.addEventListener('click', this.closeModal.bind(this));
    }

    handleMouseDown(event) {
      this.startX = event.clientX;
      this.startY = event.clientY;
      this.isDragging = false;
    }

    handleMouseUp(event) {
      const endX = event.clientX;
      const endY = event.clientY;

      if (Math.abs(endX - this.startX) > this.dragThreshold || Math.abs(endY - this.startY) > this.dragThreshold) {
        this.isDragging = true;
      }
    }

    handleClick() {
      if (!this.isDragging) {
        this.openModal();
      }
    }

    openModal() {
      this.modalContent.style.display = 'block';
      this.modalOverlayContent.style.display = 'block';
      
      requestAnimationFrame(() => {
        this.modalContent.classList.add('td-ugc__modal--active');
        this.modalOverlayContent.classList.add('td-ugc__overlay--active');
      });

      this.body.style.overflow = 'hidden';

      this.mainContainer.prepend(this.modalContent);
      this.mainContainer.prepend(this.modalOverlayContent);

      const video = this.modalContent.querySelector('video');
      if (video) {
        video.play();
        video.muted = false; 
      }
      
      document.dispatchEvent(new CustomEvent('pause-swiper'));
    }

    closeModal() {
      this.modalContent.classList.remove('td-ugc__modal--active');
      this.modalOverlayContent.classList.remove('td-ugc__overlay--active');

      this.modalContent.addEventListener('transitionend', () => {
        this.modalContent.style.display = 'none';
        this.modalOverlayContent.style.display = 'none';
      }, { once: true });

      this.body.style.overflow = 'visible';
      
      const video = this.modalContent.querySelector('video');
      if (video) {
        video.pause();
        video.currentTime = 0;
      }

      document.dispatchEvent(new CustomEvent('reset-swiper'));
    }
  }

  customElements.define("td-modal", tdModal);
}
